<!-- App Main Structure -->
<template>
  <div id="app-layout">
    <v-layout fill-height v-if="!(embed) && !bizgainLayout">
      <v-navigation-drawer
        v-model="sidebarDrawerHandler"
        id="outer-nav"
        class="vuely-sidebar hidden-sm-down"
        permenent
        fixed
        app
        :width="outerNavWidth"
        mobile-break-point="960"
      >
        <v-navigation-drawer
          dark
          fixed
          id="inner-nav"
          mini-variant-width="70"
          :mini-variant="innerNavMiniVariant"
          :right="rtlLayout"
          hide-overlay
          class="vuely-sidebar hidden-sm-down"
          v-model="sidebarDrawerHandler"
          :width="innerNavWidth"
          mobile-break-point="960"
        >
          <!-- Key is added to sidebar component because to re-render the fresh chat widget to create a new instance to different bp-->
          <template>
            <app-sidebar :key="businessProfileId" />
          </template>
        </v-navigation-drawer>
      </v-navigation-drawer>
    </v-layout>
    <v-container
      fluid
      grid-list-xl
      v-if="!customLayout"
      class="pb-0"
      :class="{'px-2':$vuetify.breakpoint.smAndDown }"
    >
      <v-layout v-if="breadcrumbs.length !== 0" py-1>
        <v-flex class="hidden-sm-and-down pa-0">
          <v-breadcrumbs
            class="py-1"
            :class="{ 'pl-0' : enableBackButton }"
            :items="breadcrumbs"
            light
          >
            <v-icon slot="divider">
              chevron_right
            </v-icon>
            <template slot="item" slot-scope="props">
              <a class="pr-2 back-btn" @click="goBack()" v-if="enableBackButton">
                <v-icon slot="divider">
                  arrow_back
                </v-icon>
              </a>
              <a v-if="!headerAddtionalInfo" @click="redirect(props.item.routeName, props.item.isBpLevelRoute)" class="breadcrumb-text fw-bold">
                {{
                  props.item.text
                }}
              </a>
              <span class="breadcrumb-text fw-bold" v-else> {{ headerAddtionalInfo }} </span>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-spacer />
        <v-flex
          md4
          sm12
          xs12
          py-0
          :class="{'mt-3':$vuetify.breakpoint.smAndDown}"
        >
          <date-range-filter v-if="$route.meta.showDateRangeFilter" class-attributes="mt-2" />
        </v-flex>
      </v-layout>
    </v-container>
    <!-- App Router -->
    <transition name="fade" mode="out-in">
      <router-view :class="{'page-container':addPageContainerCss}" :key="$route.fullPath" />
    </transition>
    <app-dialog-loader />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppDialogLoader from 'Components/AppDialogLoader/AppDialogLoader';
import Sidebar from 'Components/Sidebar/TheSidebar.vue';
import TheDateRangeFilter from 'Components/DateRangeFilter/TheDateRangeFilter';
import { bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import { Stores, StoreTypes } from 'Constants/storeTypes';
import AppConfig from 'Constants/AppConfig';
import { Chat } from 'Mixins/chat';

import {
  VNavigationDrawer,
  VContainer,
  VLayout,
  VBreadcrumbs,
  VIcon,
  VSpacer,
  VFlex
} from 'vuetify/lib';
export default {
  mixins: [Chat],
  data() {
    return {
      loading: true,
      collapsed: false, // collapse sidebar,
      storeTypes: StoreTypes,
      stores: Stores,
      chatWindowToken: AppConfig.chatWindowToken,
      chatWindowUrl: AppConfig.chatWindowUrl
    };
  },
  props: {
    embed: {
      default: false,
      type: Boolean
    }
  },
  components: {
    VContainer,
    VLayout,
    AppDialogLoader,
    VBreadcrumbs,
    VIcon,
    VSpacer,
    DateRangeFilter: TheDateRangeFilter,
    VNavigationDrawer,
    VFlex,
    appSidebar: Sidebar
  },
  computed: {
    ...mapGetters([
      'selectedRouterAnimation',
      'user',
      'isCurrencyCodeSet',
      'roimaticConfiguration',
      'rtlLayout',
      'collapseSidebar',
      'sidebarSelectedFilter',
      'sidebarDrawer',
      'outerNavWidth',
      'innerNavWidth',
      'businessProfileId',
      'roimaticFlavour',
      'headerAddtionalInfo',
      'enableBackButton',
      'isForBizgain',
      'disableChatSupport',
      'freshChatRestoreId',
      'freshChatExternalId',
      'businessName'
    ]),
    isCampaignRoute(){
      return this.$route.name == bizgainOnboardingRoutes.campaign.name
    },
    addPageContainerCss() {
      if (['editCampaign'].includes(this.$route.name)) {
        return false;
      }
      return true;
    },
    bizgainLayout() {
      return this.$route.meta.bizgainLayout;
    },
    isNavFixed(){
      return this.$route.meta.isNavFixed;
    },
    customLayout(){
      if (this.$route.meta.customLayout || this.bizgainLayout) {
        return true;
      }
      return false;
    },
    innerNavMiniVariant() {
      return this.$vuetify.breakpoint.mdAndUp && this.collapseSidebarHandler;
    },
    collapseSidebarHandler: {
      get: function() {
        return this.collapseSidebar;
      },
      // setter
      set: function() {
        this.$store.dispatch('collapseSidebar');
      }
    },
    breadcrumbs() {
      var self = this;
      return this.$breadcrumbs.map(breadcrumb => ({
        text: self.$t(breadcrumb.meta.breadcrumb),
        routeName: self.$t(breadcrumb.meta.routeName),
        isBpLevelRoute: self.$t(breadcrumb.meta.isBpLevelRoute)
      }));
    },
    sidebarDrawerHandler: {
      get: function() {
        return this.sidebarDrawer;
      },
      // setter
      set: function(value) {
        this.$store.dispatch('setSidebarDrawer', value);
      }
    }
  },
  async mounted() {
    this.setOuterNavWidth(250);
    this.$store.dispatch('setMiniSidebarLayout', false);

    if((!this.disableChatSupport) && !this.isCampaignRoute){
      /*
          Campaign route check is necessary because we initalize freshchat within main.vue for inital flow / subsequent flow
      */

      this.initializeChat(this.freshChatRestoreId, this.freshChatExternalId, this.$vuetify.theme, this.businessProfileId, this.businessName, this.user, false);
    }
  },
  methods: {
    ...mapActions(['setOuterNavWidth', 'initializeFreshChatWidget']),
    goBack() {
      this.$router.go(-1);
    },
    redirect(routeName, isBpLevelRoute){
      if(isBpLevelRoute){
        this.$router.push({ name: routeName, params: { businessProfileId: this.businessProfileId } });
      } else {
        this.$router.push({ name: routeName });
      }
    }
  },
  destroyed() {
    this.$store.dispatch('setMiniSidebarLayout', false);
  },
  watch: {
    // this is required in order to set outer navigation bar's width to allow expansion.
    // this is required here until we enable chat panel again, once chat is enabled the watch in Chat Panel will handle it
    collapseSidebar(value) {
      if (this.$vuetify.breakpoint.smAndDown) {
        return;
      }
      if (!value) {
        this.setOuterNavWidth(250);
      } else if (value) {
        this.setOuterNavWidth(70);
      }
    }
  }
};
</script>
<style scoped>
.v-breadcrumbs {
  min-height: 48px;
}
.back-btn {
  color: var(--v-gray-dark-base);
}
#inner-nav {
  background: none !important;
  box-shadow: none !important;
  z-index: 10 !important;
  visibility: visible !important;
}
#outer-nav {
  background: none !important;
  box-shadow: none !important;
  z-index: 10 !important;
  visibility: hidden;
  margin-top: calc(var(--safe-area-inset-top)*0.9) !important;
}
::v-deep #outer-nav .v-navigation-drawer__border {
  background-color: transparent !important;
}
</style>
<style lang="scss">

@media (max-width: 959px) {
  #app-layout {
    .page-container {
      padding-left: 8px !important;
      padding-right: 8px !important;
      margin-top: 10px !important;
    }
  }
}
</style>
